import React, { useState } from "react";
import { getLocalStorage, setLocalStorage } from "global/utilities/browserStorage";
import PageErrorBoundary from "global/errors/PageErrorBoundary";
import { Container, Row, FormGroup, Input, Label } from "reactstrap";

export default function AdminPage() {
	const [isAdminEnabled, setIsAdminEnabled] = useState(getLocalStorage("isAdmin") == "true");
	const [isDebugModeEnabled, setIsDebugModeEnabled] = useState(getLocalStorage("isDebugModeEnabled") == "true");
	const [adminToken, setAdminToken] = useState(getLocalStorage("adminToken"));
	const textBoxReference = React.createRef();

	const toggleAdminMode = () => {
		setLocalStorage("isAdmin", !isAdminEnabled);
		setIsAdminEnabled(!isAdminEnabled);
	};

	const toggleDebugMode = () => {
		setLocalStorage("isDebugModeEnabled", !isDebugModeEnabled);
		setIsDebugModeEnabled(!isDebugModeEnabled);
	};

	const changeAdminToken = () => {
		const value = textBoxReference.current.value.trim();
		setLocalStorage("adminToken", value);
		setAdminToken(value);
	};

	return (
		<PageErrorBoundary>
			<Container>
				<Row>
					<FormGroup switch>
						<Input type="switch" checked={isAdminEnabled} onClick={toggleAdminMode} />
						<Label check>Enable admin mode</Label>
					</FormGroup>
					<FormGroup switch>
						<Input type="switch" checked={isDebugModeEnabled} onClick={toggleDebugMode} />
						<Label check>Enable debug mode</Label>
					</FormGroup>
					<FormGroup>
						<Label for="adminTokenTextBox">
							Admin Token
						</Label>
						<Input
							id="adminTokenTextBox"
							defaultValue={adminToken}
							onChange={changeAdminToken}
							innerRef={textBoxReference}>
						</Input>
					</FormGroup>
				</Row>
			</Container>
		</PageErrorBoundary>
	);
}